import { getHeaders, SubmissionURL } from './config';
import { checkStatus } from './normalizer';
import { UpdateClaimResource } from '../types/losses.type';

export async function updateClaim(id: string, payload: UpdateClaimResource) {
    return fetch(`${SubmissionURL}/claims/${id}`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    }).then(checkStatus);
}
